module.exports = __webpack_public_path__ + "static/media/arrow-next.9dc467f4.svg";